module.exports = __webpack_public_path__ + "static/img/icon11.63201f03.png";